import React, { useState, useEffect } from "react";
import { withStyles } from "@material-ui/core/styles";
import { compose } from "recompose";
import { operators } from './views/filterEditorHelpers'
import { format as dateFormat, parseISO } from 'date-fns';

const FilterRulesViewer = ({ classes, filterValue, fields }) => {
  const [content, setContent] = useState(null)

  const treatFilterRules = (rules) => {

    const groupOperatorsWithExpression = (curr) => {
      if (curr === 'and' || curr === 'or') {
        return curr
      }
      if (Array.isArray(curr) && typeof curr[0] === 'string' && typeof curr[1] === 'string') {
        return curr;
      }
      else {
        const currCopy = [...curr]
        const ret =
          currCopy.reduce((prev, v) => {
            if ((v === 'and' || v === 'or') && prev.length > 0) {
              const topFromPrev = prev[prev.length - 1]
              if (Array.isArray(topFromPrev) && typeof topFromPrev[0] === 'string' && typeof topFromPrev[1] === 'string') {
                prev[prev.length - 1] = [...topFromPrev, v]
                return prev;
              }
            }
            const rslt = groupOperatorsWithExpression(v)
            prev.push(rslt)
            return prev;
          }, [])
        return ret
      }
    }
    
    const rulesCopy = [...rules]
    return rulesCopy.reduce((prev, v) => {
      if ((v === 'and' || v === 'or') && prev.length > 0) {
        const topFromPrev = prev[prev.length - 1]
        if (Array.isArray(topFromPrev) && typeof topFromPrev[0] === 'string' && typeof topFromPrev[1] === 'string') {
          prev[prev.length - 1] = [...topFromPrev, v]
          return prev;
        }
      }
      const r = groupOperatorsWithExpression(v)
      prev.push(r)
      return prev;
    }, [])
  }

  useEffect(() => {
    if (Array.isArray(filterValue) && typeof filterValue[0] === 'string' && typeof filterValue[1] === 'string') {
      setContent(<div style={{ fontSize: '10px' }}>{renderExpression(filterValue, 0)}</div>);
      return;
    }
    setContent(<div style={{ fontSize: '10px' }}>{transformFilterRulesInJsx(treatFilterRules(filterValue))}</div>)
  }, [filterValue])

  const transformFilterRulesInJsx = (rules) => {
    let levelOfIdentation = 0;
    return <>
      {rules.map((v, index) => {
        return checkRow(v, levelOfIdentation)
      })}
    </>
  }

  const getFieldCaptionByName = (fieldName) => {
    return fields.find(v => v.dataField === fieldName).caption;
  }

  const treatOperators = (str) => {
    return operators.find(op => op.name === str)?.caption ?? str;
  }

  const capitalizeFirstLetter = (str) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  }
  
  const renderExpression = (data, levelOfIdentation) => {
    const formatDate = date => {
      let formatted = date;
      if (typeof date === 'string') {
        formatted = parseISO(date);
      }
      return dateFormat(formatted, 'MM/dd/yyyy');
    }
    let value = data[2];
    const isDate = fields.find(v => v.dataField === data[0]).dataType === 'date';
  
    if (Array.isArray(value)) {
      value = value.map((el, index) => {
        let newEl = el;
        if (el === null) {
          newEl = '(Blanks)';
        } else if (isDate) {
          newEl = formatDate(newEl);
        }
        if (index > 0) {
          newEl = ' ' + newEl;
        }
        return newEl;
      });
    } else if (data.length > 2 && isDate) {
      if (value == null) {
        value = '(Blanks)';
      } else {
        value = formatDate(value);
      }
    }
    return (
      <div style={{ marginLeft: `${levelOfIdentation * 10}px`, marginBottom: '5px', display: 'flex' }}>
        <div className={classes.filterRulesField}>{getFieldCaptionByName(data[0])}</div>
        <div className={classes.filterRulesOperation}>{treatOperators(data[1])}</div>
        {data.length > 2 && (
          <div className={classes.filterRulesValue}>{''+value}</div>
        )}
        {data.length > 3 && (
          <div className={classes.conditionalOperator} style={{ marginLeft: '3px' }}>{capitalizeFirstLetter(data[3])}</div>
        )}
      </div>
    )
  }

  const checkRow = (curr, levelOfIdentation) => {
    if (Array.isArray(curr) && typeof curr[0] === 'string' && typeof curr[1] === 'string') {
      return renderExpression(curr, levelOfIdentation)
    }
    if (curr === 'and' || curr === 'or') {
      return <div className={classes.conditionalOperator} style={{ marginLeft: `${levelOfIdentation * 10}px`, marginBottom: '3px', display: 'flex' }}> {capitalizeFirstLetter(curr)}</div>
    }
    else {
      levelOfIdentation += 1;
      const ret = <>
        <div class={classes.block}>
          {curr.map((v, index) => {
            const rslt = checkRow(v, levelOfIdentation)
            return rslt;
          })}
        </div>
      </>
      levelOfIdentation -= -1
      return ret
    }
  }

  return (
    content && (
      <div id="container" style={{ marginBottom: -5 }}>
        {content && (content)}
      </div>)
  );
}
const styles = (theme) => ({
  filterRulesField: {
    marginRight: '7px',
    backgroundColor: 'rgba(0,73,144,.5)',
    padding: '5px',
    borderRadius: '7px'
  },
  filterRulesOperation: {
    marginRight: '7px',
    backgroundColor: 'rgba(139,195,74,.3)',
    padding: '5px',
    borderRadius: '7px'
  },
  filterRulesValue: {
    backgroundColor: 'rgba(224,224,224,.5)',
    padding: '5px',
    borderRadius: '7px'
  },
  conditionalOperator: {
    backgroundColor: 'rgba(244,67,54,.3)',
    padding: '5px',
    borderRadius: '7px',
    width: 'max-content'
  }
})
export default compose(
  withStyles(styles),
)(FilterRulesViewer);